// extracted by mini-css-extract-plugin
export default {"cancelBtn":"confirm-delete_cancelBtn__H1SEk","okBtn":"confirm-delete_okBtn__e8GIb","overlay":"confirm-delete_overlay__UnWXD","bottom":"confirm-delete_bottom__trbeF"};